import { useContext } from 'react'
import { TemplateContext } from '~/components/template/context'

export const usePlatform = () => {
  const { isMobile } = useContext(TemplateContext)
  return {
    isMobile,
  }
}
